"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var helpers_1 = require("../../utils/helpers");
exports.Input = styled_components_1.default.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  appearance: none;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  transition: 0.3s all;\n\n  ", "\n\n  height: ", ";\n\n  &:focus {\n    outline: none;\n  }\n\n  &::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: ", ";\n    height: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n    border: none;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n    margin-top: ", ";\n    cursor: pointer;\n  }\n\n  &::-moz-range-thumb {\n    -moz-appearance: none;\n    appearance: none;\n    width: ", ";\n    height: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n    border: none;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n    margin-top: ", ";\n    cursor: pointer;\n  }\n\n  &::-ms-thumb {\n    -ms-appearance: none;\n    appearance: none;\n    width: ", ";\n    height: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n    border: none;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n    margin-top: ", ";\n    cursor: pointer;\n  }\n\n  &::-webkit-slider-runnable-track {\n    height: ", ";\n    background-image: ", ";\n    border-radius: ", ";\n  }\n\n  &::-moz-range-track {\n    height: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n  }\n\n  &::-ms-track {\n    height: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n  }\n\n  &::-moz-range-progress {\n    height: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n  }\n\n  &::-ms-fill-lower {\n    height: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n  }\n"], ["\n  appearance: none;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  transition: 0.3s all;\n\n  ",
    "\n\n  height: ", ";\n\n  &:focus {\n    outline: none;\n  }\n\n  &::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: ", ";\n    height: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n    border: none;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n    margin-top: ",
    ";\n    cursor: pointer;\n  }\n\n  &::-moz-range-thumb {\n    -moz-appearance: none;\n    appearance: none;\n    width: ", ";\n    height: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n    border: none;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n    margin-top: ",
    ";\n    cursor: pointer;\n  }\n\n  &::-ms-thumb {\n    -ms-appearance: none;\n    appearance: none;\n    width: ", ";\n    height: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n    border: none;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n    margin-top: ",
    ";\n    cursor: pointer;\n  }\n\n  &::-webkit-slider-runnable-track {\n    height: ", ";\n    background-image: ",
    ";\n    border-radius: ", ";\n  }\n\n  &::-moz-range-track {\n    height: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n  }\n\n  &::-ms-track {\n    height: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n  }\n\n  &::-moz-range-progress {\n    height: ", ";\n    background-color: ", ";\n    border-radius: ",
    ";\n  }\n\n  &::-ms-fill-lower {\n    height: ", ";\n    background-color: ", ";\n    border-radius: ",
    ";\n  }\n"])), function (_a) {
    var style = _a.style;
    return helpers_1.toCSS(style.root);
}, function (_a) {
    var style = _a.style;
    return style.thumb.height;
}, function (_a) {
    var style = _a.style;
    return style.thumb.height;
}, function (_a) {
    var style = _a.style;
    return style.thumb.height;
}, function (_a) {
    var style = _a.style;
    return style.thumb.backgroundColor;
}, function (_a) {
    var style = _a.style;
    return "calc(" + style.thumb.height + " / 2)";
}, function (_a) {
    var style = _a.style;
    return "calc(((" + style.thumb.height + " - " + style.track.height + ") / 2) * -1)";
}, function (_a) {
    var style = _a.style;
    return style.thumb.height;
}, function (_a) {
    var style = _a.style;
    return style.thumb.height;
}, function (_a) {
    var style = _a.style;
    return style.thumb.backgroundColor;
}, function (_a) {
    var style = _a.style;
    return "calc(" + style.thumb.height + " / 2)";
}, function (_a) {
    var style = _a.style;
    return "calc(((" + style.thumb.height + " - " + style.track.height + ") / 2) * -1)";
}, function (_a) {
    var style = _a.style;
    return style.thumb.height;
}, function (_a) {
    var style = _a.style;
    return style.thumb.height;
}, function (_a) {
    var style = _a.style;
    return style.thumb.backgroundColor;
}, function (_a) {
    var style = _a.style;
    return "calc(" + style.thumb.height + " / 2)";
}, function (_a) {
    var style = _a.style;
    return "calc(((" + style.thumb.height + " - " + style.track.height + ") / 2) * -1)";
}, function (_a) {
    var style = _a.style;
    return style.track.height;
}, function (_a) {
    var style = _a.style, percent = _a.percent;
    return "linear-gradient(90deg, " + style.track.backgroundColor + " " + percent + ", " + style.rail.backgroundColor + " " + percent + ")";
}, function (_a) {
    var style = _a.style;
    return "calc(" + style.track.height + " / 2)";
}, function (_a) {
    var style = _a.style;
    return style.track.height;
}, function (_a) {
    var style = _a.style;
    return style.rail.backgroundColor;
}, function (_a) {
    var style = _a.style;
    return "calc(" + style.track.height + " / 2)";
}, function (_a) {
    var style = _a.style;
    return style.track.height;
}, function (_a) {
    var style = _a.style;
    return style.rail.backgroundColor;
}, function (_a) {
    var style = _a.style;
    return "calc(" + style.track.height + " / 2)";
}, function (_a) {
    var style = _a.style;
    return style.track.height;
}, function (_a) {
    var style = _a.style;
    return style.track.backgroundColor;
}, function (_a) {
    var style = _a.style;
    return "calc(" + style.track.height + " / 2) 0 0 calc(" + style.track.height + " / 2)";
}, function (_a) {
    var style = _a.style;
    return style.track.height;
}, function (_a) {
    var style = _a.style;
    return style.track.backgroundColor;
}, function (_a) {
    var style = _a.style;
    return "calc(" + style.track.height + " / 2) 0 0 calc(" + style.track.height + " / 2)";
});
var templateObject_1;
//# sourceMappingURL=styles.js.map